import { render, staticRenderFns } from "./ReferenceFilterHeader.vue?vue&type=template&id=548731da&scoped=true&"
import script from "./ReferenceFilterHeader.vue?vue&type=script&lang=js&"
export * from "./ReferenceFilterHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceFilterHeader.vue?vue&type=style&index=0&id=548731da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548731da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VIcon})
